var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass:
        "w-6 h-9 md:w-4 md:h-7 border border-gray-300 bg-gray-200 rounded flex justify-center items-center transition-colors hover:bg-gray-300",
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [_c("GrmIcon", { attrs: { icon: `arrow-${_vm.icon}` } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }